import I18n from "lib/i18n/i18n";

export const menuItems = {
    baseItems: [
        {
            "title": I18n.getString('header::menu::titles::sellYourItem'),
            "rootLink": "/about/how-it-works",
            "mobile": 1,
            "desktop": false
        },
        {
            "title": I18n.getString('header::menu::titles::howItWorks'),
            "rootLink": "/about/how-it-works",
            "mobile": 2
        },
        {
            "title": I18n.getString('header::menu::titles::recentAuctions'),
            "rootLink": "/about/recent-deals/rings",
            "mobile": false
        },
        {
            "title": I18n.getString('header::menu::titles::sellingSafely'),
            "rootLink": "/about/selling-with-trust",
            "mobile": 3
        },
        {
            "title": I18n.getString('header::menu::titles::acceptItems'),
            "rootLink": "/about/what-we-accept",
            "mobile": false
        },
        {
            "title": I18n.getString('header::menu::titles::aboutUs'),
            "rootLink": "/about",
            "mobile": 5,
            "subItems": [
                {
                    "title": I18n.getString('header::menu::titles::about'),
                    "rootLink": "/about",
                    "mobile": false
                },
                {
                    "title": I18n.getString('header::menu::titles::contactUs'),
                    "rootLink": "/about/contact",
                    "mobile": 9
                },
                {
                    "title": I18n.getString('header::menu::titles::scholarship'),
                    "rootLink": "/about/scholarship",
                    "mobile": false
                },
                {
                    "title": I18n.getString('header::menu::titles::sellingSafely'),
                    "rootLink": "/about/selling-with-trust",
                    "mobile": false
                },
                {
                    "title": I18n.getString('header::menu::titles::certsAndLicenses'),
                    "rootLink": "/about/certifications-licenses",
                    "mobile": false
                },
                {
                    "title": I18n.getString('header::menu::titles::reviews'),
                    "rootLink": "/about/reviews",
                    "mobile": 4
                },
                {
                    "title": I18n.getString('header::menu::titles::successStories'),
                    "rootLink": "/about/success-stories",
                    "mobile": false
                },
                {
                    "title": I18n.getString('header::menu::titles::faqs'),
                    "rootLink": "/about/faqs",
                    "mobile": 6
                },
                {
                    "title": I18n.getString('header::menu::titles::board'),
                    "rootLink": "/about/board",
                    "mobile": false
                },
                {
                    "title": I18n.getString('header::menu::titles::press'),
                    "rootLink": "/about/worthy-press",
                    "mobile": 7
                },
                {
                    "title": I18n.getString('header::menu::titles::blog'),
                    "rootLink": "/blog/",
                    "mobile": 8
                },
                {
                    "title": I18n.getString('header::menu::titles::promotions'),
                    "rootLink": "/promotions",
                    "mobile": false
                }
            ]
        },
        {
            "title": I18n.getString('header::menu::titles::sell'),
            "rootLink": "/form#itemCategories",
            "mobile": false,
            "subItems": [
                {
                    "title": I18n.getString('header::menu::titles::sellDiamonds'),
                    "rootLink": "sell-diamonds",
                    "mobile": false
                },
                {
                    "title": I18n.getString('header::menu::titles::sellWatches'),
                    "rootLink": "sell-watches",
                    "mobile": false
                },
                {
                    "title": I18n.getString('header::menu::titles::sellJewelry'),
                    "rootLink": "sell-jewelry",
                    "mobile": false
                },
                {
                    "title": I18n.getString('header::menu::titles::sellEngagementRing'),
                    "rootLink": "sell-jewelry/engagement-ring",
                    "mobile": false
                },
                {
                    "title": I18n.getString('header::menu::titles::sellGemstones'),
                    "rootLink": "sell-gemstones",
                    "mobile": false
                }
            ]
        },
        {
            "title": I18n.getString('header::menu::titles::blog'),
            "rootLink": "/blog/",
            "mobile": false
        }
    ],
    signInItems: {
        loggedIn: {
            "title": I18n.getString('header::menu::titles::hi'),
            "link": "/items",
            "mobile": false,
            "subItems": [
                {
                    "title": I18n.getString('header::menu::titles::myAccount'),
                    "link": "/items",
                    "mobile": 10
                },
                {
                    "title": I18n.getString('header::menu::titles::logOut'),
                    "mobile": 12,
                    "rootLink": "/users/sign_out"
                }]
        },
        signIn: {
            "title": I18n.getString('header::menu::titles::logIn'),
            "link": "/signin",
            "mobile": 10
        }
    }
};

export const CARAT_WEIGHT_SUGGESTION_MAX_VALUE = 15;

export const PENDING_REVIEW = 1;

